module.exports = __webpack_public_path__ + "media/images/badge/campionato-bracket-perfetto-8799b291ef163b095ab4c8bd43246079.png";